import { render } from "./IdResolution.vue?vue&type=template&id=3c1a0bf6"
import script from "./IdResolution.vue?vue&type=script&lang=js"
export * from "./IdResolution.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__